<template>
  <div class="storeAddEdit">
    <form @submit.prevent="saveStore">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="xl"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2"> {{ input ? 'Edit' : 'Add' }} Outlet </span>
        </div>
        <div>
          <b-card no-body>
            <b-tabs v-model="activeTab" card>
              <b-tab ref="outlet_info" title="Outlet Info" active>
                <b-card-text>
                  <b-row>
                    <b-col md="2">
                      <label>OutletCode</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('outletCode') }"
                    >
                      <b-form-input
                        v-model="obj.outlet_code"
                        v-validate="'required|numeric'"
                        type="text"
                        name="outletCode"
                        :disabled="!!input"
                      />
                      <small>{{ errors.first('outletCode') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="5">
                      <b-button
                        variant="success"
                        :disabled="syncRestaurantDetail.isSyncing || !obj.outlet_code"
                        @click="restaurantSync"
                      >
                        <b-spinner v-if="syncRestaurantDetail.isSyncing" small />Sync
                        restaurant by outletCode
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>Name</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('name') }">
                      <b-form-input
                        v-model="obj.name"
                        v-validate="'required'"
                        type="text"
                        name="name"
                      />
                      <small>{{ errors.first('name') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>PhoneNumber</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('phoneNumber') }"
                    >
                      <b-form-input
                        v-model="obj.phone_number"
                        v-validate="'phoneNumberFormat'"
                        type="text"
                        name="phoneNumber"
                      />
                      <small>{{ errors.first('phoneNumber') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>Address</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('address') }">
                      <b-form-input
                        v-model="obj.address"
                        v-validate="'required'"
                        type="text"
                        name="address"
                      />
                      <small>{{ errors.first('address') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>TaxPercentage</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('taxPercentage') }"
                    >
                      <b-form-input
                        v-model.number="obj.tax_percentage"
                        v-validate="'required|numeric'"
                        type="number"
                        name="taxPercentage"
                      />
                      <small>{{ errors.first('taxPercentage') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>CityCode</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('cityCode') }">
                      <b-form-input
                        v-model="obj.city_code"
                        v-validate="'required|alpha_num'"
                        type="text"
                        name="cityCode"
                      />
                      <small>{{ errors.first('cityCode') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>CityName</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('cityName') }">
                      <b-form-input
                        v-model="obj.city_name"
                        v-validate="'required'"
                        type="text"
                        name="cityName"
                      />
                      <small>{{ errors.first('cityName') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>AreaCode</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('areaCode') }">
                      <b-form-input
                        v-model="obj.area_code"
                        v-validate="'required|alpha_num'"
                        type="text"
                        name="areaCode"
                      />
                      <small>{{ errors.first('areaCode') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>AreaName</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('areaName') }">
                      <b-form-input
                        v-model="obj.area_name"
                        v-validate="'required'"
                        type="text"
                        name="areaName"
                      />
                      <small>{{ errors.first('areaName') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>Latitude</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('latitude') }">
                      <b-form-input
                        v-model.number="obj.latitude"
                        v-validate="'required'"
                        type="text"
                        name="latitude"
                      />
                      <small>{{ errors.first('latitude') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>Longitude</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('longitude') }"
                    >
                      <b-form-input
                        v-model.number="obj.longitude"
                        v-validate="'required'"
                        type="text"
                        name="longitude"
                      />
                      <small>{{ errors.first('longitude') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>IsOpen24Hours</label>
                    </b-col>
                    <b-col md="3" class="mt-1">
                      <b-form-checkbox v-model="obj.is_open24_hours" />
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>IsActive</label>
                    </b-col>
                    <b-col md="3" class="mt-1">
                      <b-form-checkbox v-model="obj.is_active" />
                    </b-col>
                  </b-row>
                  <!--  -->
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>WhatsApp</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('whatsAppID') }"
                    >
                      <b-form-input
                        v-model="obj.whats_app_id"
                        v-validate="'whatsAppIDFormat'"
                        type="text"
                        name="whatsAppID"
                      />
                      <small>{{ errors.first('whatsAppID') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>RestaurantTax</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('restaurantTax') }"
                    >
                      <b-form-input
                        v-model.number="obj.restaurant_tax"
                        v-validate="'required|numeric'"
                        type="number"
                        name="restaurantTax"
                      />
                      <small>{{ errors.first('restaurantTax') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>IsTestMode</label>
                    </b-col>
                    <b-col md="3" class="mt-1">
                      <b-form-checkbox v-model="obj.is_test_mode" />
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>EDC Model</label>
                    </b-col>
                    <b-col md="3" class="mt-1">
                      <b-form-checkbox v-model="obj.edc_model" />
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab ref="order_setting" title="Order Setting">
                <b-card-text>
                  <b-row class="typeCheck">
                    <b-col md="2">
                      <label>Store Type</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl">
                      <span>QSR (without table number)</span>
                      <b-form-checkbox
                        v-model="qsrTableNumber"
                        class="speedyCheckbox qsrCheck"
                        @change="selectQsrTable($event)"
                      />
                    </b-col>
                    <b-col md="1" />
                    <b-col md="3" class="mt-1 fl">
                      <span>FSR (with table number)</span>
                      <b-form-checkbox
                        v-model="fsrTableNumber"
                        class="speedyCheckbox fsrCheck"
                        @change="selectFsrTable($event)"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>EDC: Phone Input Required</label>
                    </b-col>
                    <b-col md="10" class="mt-1">
                      <b-form-checkbox v-model="obj.phone_input_required" :value="1" :unchecked-value="0">
                        <span style="color: #828282; font-size: 13px; position: relative; top: -3px;">Hides the Lewati (Skip) button — cashier must enter customer phone.</span>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>EDC: Brand-New Customer Treatment</label>
                    </b-col>
                    <b-col md="10" class="mt-1">
                      <b-form-checkbox v-model="obj.brand_new_customer_treatment" :value="1" :unchecked-value="0">
                        <span style="color: #828282; font-size: 13px; position: relative; top: -3px;">For customers with no prior completed orders at this brand: show a NEW badge next to the phone number in the confirmation modal.</span>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>Order type</label>
                      <small v-if="isOrderType"> Order type is required </small>
                    </b-col>
                    <div class="orderAlign">
                      <div class="mrSpeedy">
                        <div class="typeCheckBox">
                          <b-form-checkbox
                            v-model="orderTakeaway"
                            class="speedyCheckbox"
                            @change="selectTakeAway($event)"
                          />
                          <h4>Takeaway</h4>
                        </div>
                        <div v-if="orderTakeaway" class="chargeBox">
                          <div class="chargeInput">
                            <span>
                              VAT
                              <small style="color: #828282"> (Takeaway) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('takeAwayVat') }"
                            >
                              <b-input-group append="%">
                                <b-form-input
                                  v-model="takeAwayVat"
                                  v-validate="'required|characters|serviceCharge'"
                                  type="text"
                                  name="takeAwayVat"
                                />
                              </b-input-group>
                              <small>{{ errors.first('takeAwayVat') }}</small>
                            </div>
                          </div>
                          <div class="chargeInput">
                            <span>
                              Processing Fee
                              <small style="color: #828282"> (Takeaway) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('takeAwayFee') }"
                            >
                              <b-input-group append="Rp">
                                <b-form-input
                                  v-model="takeAwayFee"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  name="takeAwayFee"
                                />
                              </b-input-group>
                              <small>{{ errors.first('takeAwayFee') }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mrSpeedy">
                        <div class="typeCheckBox">
                          <b-form-checkbox
                            v-model="orderDelivery"
                            class="speedyCheckbox"
                            @change="selectDelivery($event)"
                          />
                          <h4>Delivery</h4>
                        </div>
                        <div v-if="orderDelivery" class="chargeBox">
                          <div class="chargeInput">
                            <span>
                              VAT
                              <small style="color: #828282"> (Delivery) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('deliveryVat') }"
                            >
                              <b-input-group append="%">
                                <b-form-input
                                  v-model="deliveryVat"
                                  v-validate="'required|characters|serviceCharge'"
                                  type="text"
                                  name="deliveryVat"
                                />
                              </b-input-group>
                              <small>{{ errors.first('deliveryVat') }}</small>
                            </div>
                          </div>
                          <div class="chargeInput">
                            <span>
                              Processing Fee
                              <small style="color: #828282"> (Delivery) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('deliveryFee') }"
                            >
                              <b-input-group append="Rp">
                                <b-form-input
                                  v-model="deliveryFee"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  name="deliveryFee"
                                />
                              </b-input-group>
                              <small>{{ errors.first('deliveryFee') }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="!fsrTableNumber" class="mrSpeedy">
                        <div class="typeCheckBox">
                          <b-form-checkbox
                            v-model="dineInStatus"
                            class="speedyCheckbox"
                            @change="selectDineIn($event)"
                          />
                          <h4>Dine In</h4>
                        </div>
                        <div v-if="dineInStatus" class="chargeBox">
                          <div class="chargeInput">
                            <span>
                              VAT
                              <small style="color: #828282"> (Dine In) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('dineinVat') }"
                            >
                              <b-input-group append="%">
                                <b-form-input
                                  v-model="dineInVat"
                                  v-validate="'required|characters|serviceCharge'"
                                  type="text"
                                  name="dineinVat"
                                />
                              </b-input-group>
                              <small>{{ errors.first('dineinVat') }}</small>
                            </div>
                          </div>
                          <div class="chargeInput">
                            <span>
                              Processing Fee
                              <small style="color: #828282"> (Dine In) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('dineinFee') }"
                            >
                              <b-input-group append="Rp">
                                <b-form-input
                                  v-model="dineInFee"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  name="dineinFee"
                                />
                              </b-input-group>
                              <small>{{ errors.first('dineinFee') }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="fsrTableNumber" class="mrSpeedy">
                        <div class="typeCheckBox">
                          <b-form-checkbox
                            v-model="tableOrder"
                            class="speedyCheckbox"
                            @change="selectTableOrder($event)"
                          />
                          <h4>Table Order</h4>
                        </div>
                        <div v-if="tableOrder" class="chargeBox">
                          <div class="chargeInput">
                            <span>
                              VAT
                              <small style="color: #828282"> (Table Order) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('tableOrderVat') }"
                            >
                              <b-input-group append="%">
                                <b-form-input
                                  v-model="tableOrderVat"
                                  v-validate="'required|characters|serviceCharge'"
                                  type="text"
                                  name="tableOrderVat"
                                />
                              </b-input-group>
                              <small>{{ errors.first('tableOrderVat') }}</small>
                            </div>
                          </div>
                          <div class="chargeInput">
                            <span>
                              Processing Fee
                              <small style="color: #828282"> (Table Order) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{ 'form-error': errors.first('tableOrderFee') }"
                            >
                              <b-input-group append="Rp">
                                <b-form-input
                                  v-model="tableOrderFee"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  name="tableOrderFee"
                                />
                              </b-input-group>
                              <small>{{ errors.first('tableOrderFee') }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="showRoomService" class="mrSpeedy">
                        <div class="typeCheckBox">
                          <b-form-checkbox
                            v-model="roomServiceStatus"
                            class="speedyCheckbox"
                            @change="selectRoomService($event)"
                          />
                          <h4>Room Service</h4>
                        </div>
                        <div v-if="roomServiceStatus" class="chargeBox">
                          <div class="chargeInput">
                            <span>
                              VAT
                              <small style="color: #828282"> (Room Service) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{
                                'form-error': errors.first('roomServiceVat'),
                              }"
                            >
                              <b-input-group append="%">
                                <b-form-input
                                  v-model="roomServiceVat"
                                  v-validate="'required|characters|serviceCharge'"
                                  type="text"
                                  name="roomServiceVat"
                                />
                              </b-input-group>
                              <small>{{ errors.first('roomServiceVat') }}</small>
                            </div>
                          </div>
                          <div class="chargeInput">
                            <span>
                              Processing Fee
                              <small style="color: #828282"> (Room Service) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{
                                'form-error': errors.first('roomServiceFee'),
                              }"
                            >
                              <b-input-group append="Rp">
                                <b-form-input
                                  v-model="roomServiceFee"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  name="roomServiceFee"
                                />
                              </b-input-group>
                              <small>{{ errors.first('roomServiceFee') }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mrSpeedy">
                        <div class="typeCheckBox">
                          <b-form-checkbox
                            v-model="orderOthers"
                            class="speedyCheckbox"
                            @change="selectOthersOrder($event)"
                          />
                          <h4>OTHERS</h4>
                        </div>
                        <div v-if="orderOthers" class="chargeBox">
                          <div class="chargeInput">
                            <span>
                              Processing Fee
                              <small style="color: #828282"> (OTHERS) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{
                                'form-error': errors.first('othersFee'),
                              }"
                            >
                              <b-input-group append="Rp">
                                <b-form-input
                                  v-model="othersFee"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  name="othersFee"
                                />
                              </b-input-group>
                              <small>{{ errors.first('othersFee') }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mrSpeedy">
                        <div class="typeCheckBox">
                          <b-form-checkbox
                            v-model="orderPos"
                            class="speedyCheckbox"
                            @change="selectPosOrder($event)"
                          />
                          <h4>POS</h4>
                        </div>
                        <div v-if="orderPos" class="chargeBox">
                          <div class="chargeInput">
                            <span>
                              Processing Fee
                              <small style="color: #828282"> (POS) </small>
                            </span>
                            <div
                              class="errorGroup"
                              :class="{
                                'form-error': errors.first('posFee'),
                              }"
                            >
                              <b-input-group append="Rp">
                                <b-form-input
                                  v-model="posFee"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  name="posFee"
                                />
                              </b-input-group>
                              <small>{{ errors.first('posFee') }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-row>
                  <b-row>
                    <b-col md="2">
                      <label>Only Dine in Order</label>
                    </b-col>
                    <b-col md="10" class="mt-1 fl">
                      <b-form-radio-group
                        v-model="obj.only_dine_in"
                        :options="onlyDineInOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="2">
                      <label>POS Input</label>
                    </b-col>
                    <b-col md="10" class="mt-1 fl">
                      <b-form-radio-group
                        v-model="obj.is_pos_input"
                        :options="posInputOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>Order Processing</label>
                    </b-col>
                    <b-col md="10" class="mt-1 fl">
                      <b-form-radio-group
                        v-model="obj.order_state_machine"
                        :options="orderStateMachineOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>BO Order Auto Completed</label>
                    </b-col>
                    <b-col md="10" class="mt-1 fl">
                      <b-form-radio-group
                        v-model="obj.bo_auto_completed"
                        :options="boAutoCompletedOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>Receipt Number Input</label>
                    </b-col>
                    <b-col md="10" class="mt-1 fl">
                      <b-form-checkbox v-model="obj.pos_active" :value="1" :unchecked-value="0" />
                    </b-col>
                  </b-row>
                  <b-row v-if="obj.pos_active" class="ml-3">
                    <b-col md="2">
                      <label>POS Name</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('posName') }"
                    >
                      <b-form-input
                        v-model="obj.pos_name"
                        v-validate="'required|maxLength:30'"
                        type="text"
                        name="posName"
                      />
                      <small>{{ errors.first('posName') }}</small>
                    </b-col>
                  </b-row>
                  <b-row v-if="obj.pos_active" class="ml-3">
                    <b-col md="2">
                      <label>Mandatory</label>
                    </b-col>
                    <b-col md="10" class="mt-1 fl">
                      <b-form-checkbox v-model="obj.pos_order_required" :value="1" :unchecked-value="0" />
                    </b-col>
                  </b-row>
                  <b-row v-if="isServiceChargeShow" class="mt-2">
                    <b-col md="2">
                      <label>Service Charge</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('serviceCharge') }"
                    >
                      <b-input-group append="%">
                        <b-form-input
                          v-model="serviceCharge"
                          v-validate="'required|characters|serviceCharge'"
                          type="text"
                          name="serviceCharge"
                          @change="changeDistance"
                        />
                      </b-input-group>
                      <small>{{ errors.first('serviceCharge') }}</small>
                    </b-col>
                  </b-row>
                  <b-row v-if="isServiceChargeShow" class="mt-2">
                    <b-col md="2">
                      <label>Service Charge Taxable</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{
                        'form-error': errors.first('is_exclude_fee_taxable'),
                      }"
                    >
                      <b-form-checkbox
                        :checked="!obj.is_exclude_fee_taxable"
                        class="speedyCheckbox"
                        @change="selectIsExcludeFeeTaxable"
                      />
                      <small>{{ errors.first('is_exclude_fee_taxable') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>Half Menu Sales</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('halfMenuSales') }"
                    >
                      <b-form-input
                        v-model="obj.half_menu_cal_rate"
                        v-validate="'required|characters|minVal:1'"
                        type="text"
                        name="halfMenuSales"
                      />
                      <small>{{ errors.first('halfMenuSales') }}</small>
                    </b-col>
                  </b-row>
                  <b-row v-if="isPaymentOrderShow" class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>Payment Order</label>
                    </b-col>
                    <b-col md="2" class="mt-1 fl">
                      <span>Before order made</span>
                      <b-form-checkbox
                        v-model="beforeOrderMade"
                        class="speedyCheckbox beforeOrder"
                        @change="changeBeforeMader($event)"
                      />
                    </b-col>
                    <b-col md="1" />
                    <b-col md="3" class="mt-1 fl afterOrder">
                      <span>After order made</span>
                      <b-form-checkbox
                        v-model="afterOrderMade"
                        class="speedyCheckbox"
                        @change="changeAfterMade($event)"
                      />
                    </b-col>
                  </b-row>
                  <b-row v-if="userType === 'Admin'" class="mt-2">
                    <b-col md="2">
                      <span>Rounding Total Calculation</span>
                    </b-col>
                    <b-col md="3">
                      <b-form-checkbox
                        :checked="obj.total_rounding_type !== 0"
                        @change="changeTotalRoundingType"
                      />
                    </b-col>
                  </b-row>
                  <b-row
                    v-if="obj.total_rounding_type && userType === 'Admin'"
                    class="mt-2"
                  >
                    <b-col md="2">
                      <label>Rounding Calculation</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('rounding') }">
                      <b-input-group>
                        <b-form-select
                          v-model="obj.total_rounding_type"
                          :options="[
                            { value: 1, text: 'UP' },
                            { value: 2, text: 'DOWN' },
                            { value: 3, text: 'NEAREST' },
                          ]"
                        />
                        <b-form-select
                          v-model="obj.total_rounding_value"
                          :options="[
                            { value: 10, text: 'Rp. 10' },
                            { value: 100, text: 'Rp. 100' },
                            { value: 1000, text: 'Rp. 1000' },
                          ]"
                        />
                      </b-input-group>

                      <small>{{ errors.first('rounding') }}</small>
                    </b-col>
                    <b-col md="1" />
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>Minimum Order Value</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('minCharge') }"
                    >
                      <b-form-input
                        v-model.number="obj.min_charge"
                        v-validate="'required|numeric'"
                        type="number"
                        name="minCharge"
                      />
                      <small>{{ errors.first('minCharge') }}</small>
                    </b-col>
                    <b-col md="1" />
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab ref="payment_setting" title="Payment Setting">
                <b-card-text>
                  <b-row v-if="obj.is_pos_input !== 0">
                    <b-col md="2">
                      <label>Payment Method</label>
                    </b-col>
                    <b-col md="6" class="mt-1 fl">
                      <b-form-radio-group
                        v-model="obj.payment_method"
                        :options="paymentMethodOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                  <b-row
                    v-if="obj.is_pos_input !== 0 && obj.payment_method === 'CIMB'"
                    class="mt-2"
                  >
                    <b-col md="2">
                      <label>CIMB MID</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('CIMBMID') }">
                      <input
                        v-model="obj.cimb_merchant_id"
                        v-validate="'required'"
                        maxlength="30"
                        type="text"
                        name="CIMBMID"
                        class="form-control"
                      />
                      <small>{{ errors.first('CIMBMID') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>CIMB TID</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('CIMBTID') }">
                      <input
                        v-model="obj.cimb_terminal_id"
                        v-validate="'required'"
                        maxlength="30"
                        type="text"
                        name="CIMBTID"
                        class="form-control"
                      />
                      <small>{{ errors.first('CIMBTID') }}</small>
                    </b-col>
                  </b-row>
                  <b-row
                    v-if="obj.is_pos_input !== 0 && obj.payment_method === 'Astrapay'"
                    class="mt-2"
                  >
                    <b-col md="2">
                      <label>Astrapay MID</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('AstrapayMID') }">
                      <input
                        v-model="obj.astrapay_merchant_id"
                        v-validate="'required'"
                        maxlength="30"
                        type="text"
                        name="AstrapayMID"
                        class="form-control"
                      />
                      <small>{{ errors.first('AstrapayMID') }}</small>
                    </b-col>
                    <b-col md="1" />
                    <b-col md="2">
                      <label>Astrapay TID</label>
                    </b-col>
                    <b-col md="3" :class="{ 'form-error': errors.first('AstrapayTID') }">
                      <input
                        v-model="obj.astrapay_terminal_id"
                        v-validate="'required'"
                        maxlength="30"
                        type="text"
                        name="AstrapayTID"
                        class="form-control"
                      />
                      <small>{{ errors.first('AstrapayTID') }}</small>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>EDC Payment</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="edc_payment_new_flow"
                        v-model="edc_payment_new_flow"
                        @change="selectOptions($event, 'edc_payment_new_flow')"
                      />
                      <label for="edc_payment_new_flow">New Flow</label>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>QRIS - AstraPay</label>
                    </b-col>
                    <b-col md="2" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="qdo_astrapay_payment"
                        v-model="obj.qdo_astrapay_payment"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="qdo_astrapay_payment">QDO</label>
                    </b-col>
                    <b-col md="2" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="bo_astrapay_payment"
                        v-model="obj.bo_astrapay_payment"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="bo_astrapay_payment">BO</label>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>Offline Payment</label>
                    </b-col>
                    <b-col md="2" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="qdo_offline_payment"
                        v-model="qdo_offline_payment"
                        @change="selectOptions($event, 'qdo_offline_payment')"
                      />
                      <label for="qdo_offline_payment">QDO</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="bo_offline_payment"
                        v-model="bo_offline_payment"
                        @change="selectOptions($event, 'bo_offline_payment')"
                      />
                      <label for="bo_offline_payment">BO (Dine In/Takeway)</label>
                    </b-col>
                  </b-row>
                  <b-row v-if="obj.is_pos_input" class="mt-2">
                    <b-col md="2">
                      <label>EDC QRIS</label>
                    </b-col>
                    <b-col md="10" class="mt-1 fl">
                      <b-form-radio-group
                        v-model="obj.edc_qris"
                        :options="edcQRISOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>EDC Ottopay</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="edc_online_payment_ottopay"
                        v-model="obj.edc_online_payment.ottopay"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="edc_online_payment_ottopay">QRIS Ottopay</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="edc_online_payment_debit"
                        v-model="obj.edc_online_payment.debit"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="edc_online_payment_debit">Debit Card</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="edc_online_payment_credit"
                        v-model="obj.edc_online_payment.credit"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="edc_online_payment_credit">Credit Card</label>
                    </b-col>
                  </b-row>
                  <OttoPaySettings :outlet-code="String(obj.outlet_code || '')" :selected="Boolean(obj.edc_online_payment.ottopay)" />
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>EDC CIMB</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="edc_cimb_payment_qris"
                        v-model="obj.edc_cimb_payment.qris"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="edc_cimb_payment_qris">QRIS</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="edc_cimb_payment_debit"
                        v-model="obj.edc_cimb_payment.debit"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="edc_cimb_payment_debit">Debit Card</label>
                    </b-col>
                    <b-col md="3" class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="edc_cimb_payment_credit"
                        v-model="obj.edc_cimb_payment.credit"
                        :value="1"
                        :unchecked-value="0"
                      />
                      <label for="edc_cimb_payment_credit">Credit Card</label>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2 typeCheck">
                    <b-col md="2">
                      <label>EDC Offline</label>
                    </b-col>
                    <b-col>
                      <b-row>
                        <b-col v-for="(item, index) in edcOfflinePaymentOptions" :key="`${item.key}_${item.key}`" md="3" class="mt-1 fl justify-content-start align-items-center">
                          <b-form-checkbox
                            :id="`edc_offline_payment_${item.key}_${index}`"
                            v-model="obj.edc_offline_payment[item.key]"
                            :value="1"
                            :unchecked-value="0"
                          />
                          <label :for="`edc_offline_payment_${item.key}_${index}`">{{ item.text }}</label>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row v-if="checkEdcOrderFlowRole && obj.edc_model" class="mt-2">
                    <b-col md="2">
                      <label>EDC Order Flow</label>
                    </b-col>
                    <b-col md="10">
                      <b-form-radio-group
                        v-model="obj.edc_order_flow_type"
                        :options="edcOrderFlowOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab ref="delivery_setting" title="Delivery Setting">
                <b-card-text>
                  <b-row v-if="isMethodShow">
                    <b-col md="2">
                      <label>Delivery Method</label>
                    </b-col>
                    <div class="sendby">
                      <h4>Send by Outlet</h4>
                      <b-form-checkbox
                        v-model="checkoutBoxStatus"
                        class="sendby-checkbox"
                        @change="changeOutletStatus($event)"
                      />
                    </div>
                    <div class="mrSpeedy">
                      <h4>3rd party delivery (Mr Speedy or Shipper.id)</h4>
                      <b-form-checkbox
                        v-model="deliveryMethod"
                        class="speedyCheckbox"
                        @change="selectDeliveryMethod($event)"
                      />
                    </div>
                  </b-row>
                  <div v-if="deliveryMethod && isMethodShow" class="speedyBoxStatus">
                    <b-col md="3" class="md">
                      <label>MaxDistance</label>
                    </b-col>
                    <b-input-group append="KM">
                      <b-form-input
                        v-model.number="maxDistance"
                        type="number"
                        name="maxDistance"
                        :step="0.1"
                        @change="changeDistance"
                      />
                    </b-input-group>
                  </div>
                  <div v-if="!deliveryMethod && isMethodShow" class="speedyStatus">
                    <b-row v-if="obj.delivery_fee && obj.delivery_fee.length">
                      <b-col md="2" />
                      <b-col md="3">
                        <label>Distance</label>
                      </b-col>
                      <b-col md="3">
                        <label>Order Value</label>
                      </b-col>
                      <b-col md="3">
                        <label>Delivery Charge</label>
                      </b-col>
                      <b-col md="1" />
                    </b-row>
                    <div>
                      <b-row
                        v-for="(items, key) in farthestDistance"
                        :key="key"
                        class="mt-1"
                      >
                        <b-col md="2" />
                        <b-col
                          md="3"
                          :class="{ 'form-error': errors.first(`distance_${key}`) }"
                        >
                          <b-input-group append="KM">
                            <b-form-input
                              v-model.number="items.distance"
                              v-validate="'required'"
                              :step="0.1"
                              type="number"
                              :name="`distance_${key}`"
                              placeholder="Distance"
                            />
                          </b-input-group>
                          <small>{{ errors.first(`distance_${key}`) }}</small>
                        </b-col>
                      </b-row>
                    </div>
                    <div>
                      <b-row
                        v-for="(items, key) in obj.delivery_fee"
                        :key="key"
                        class="mt-1"
                      >
                        <b-col md="2" />
                        <b-col
                          md="3"
                          :class="{ 'form-error': errors.first(`distance_${key}`) }"
                        >
                          <b-input-group append="KM">
                            <b-form-input
                              v-model.number="items.distance"
                              v-validate="'required'"
                              :step="0.1"
                              type="number"
                              :name="`distance_${key}`"
                              placeholder="Distance"
                            />
                          </b-input-group>
                          <small>{{ errors.first(`distance_${key}`) }}</small>
                        </b-col>
                        <b-col
                          md="3"
                          :class="{ 'form-error': errors.first(`orderValue_${key}`) }"
                        >
                          <b-form-input
                            v-model.number="items.orderValue"
                            v-validate="'required'"
                            type="number"
                            :name="`orderValue_${key}`"
                            placeholder="Order Value"
                          />
                          <small>{{ errors.first(`orderValue_${key}`) }}</small>
                        </b-col>
                        <b-col
                          md="3"
                          :class="{ 'form-error': errors.first(`price_${key}`) }"
                        >
                          <b-form-input
                            v-model.number="items.price"
                            v-validate="'required'"
                            type="number"
                            :name="`price_${key}`"
                            placeholder="Delivery Charge"
                          />
                          <small>{{ errors.first(`price_${key}`) }}</small>
                        </b-col>
                        <b-col
                          md="1"
                          style="align-self: center; cursor: pointer; color: #3d8bc1"
                          @click="removeDeliveryFeeItem(key)"
                        >
                          X
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <b-row v-if="checkoutBoxStatus && isMethodShow" class="mt-1">
                    <b-col md="2" />
                    <b-col>
                      <span
                        style="cursor: pointer; color: #3d8bc1"
                        @click="addDeliveryFeeItem"
                      >
                        + Add New Item
                      </span>
                    </b-col>
                  </b-row>
                  <!-- ---------room service---------- -->
                  <b-row v-if="isRoomServiceFeeShow" class="mt-2">
                    <b-col md="2">
                      <label>Room Service Fee</label>
                    </b-col>
                    <div style="margin-left: 14px; width: 60%">
                      <b-row v-if="obj.building_fee && obj.building_fee.length">
                        <b-col md="8">
                          <label>QR Code</label>
                        </b-col>
                        <b-col md="3">
                          <label>Fee</label>
                        </b-col>
                      </b-row>
                      <div>
                        <b-row
                          v-for="(items, key) in obj.building_fee"
                          :key="key"
                          class="mt-1"
                        >
                          <b-col
                            md="8"
                            :class="{ 'form-error': errors.first(`qrCode_${key}`) }"
                          >
                            <b-input-group>
                              <b-form-input
                                v-model="items.building_name"
                                v-validate="'required'"
                                type="text"
                                :name="`qrCode_${key}`"
                                placeholder="QR Code"
                                :list="`qrCode_list_${key}`"
                                @change="changeQr($event, items)"
                              />
                            </b-input-group>
                            <datalist
                              v-if="obj.building_list"
                              :id="`qrCode_list_${key}`"
                            >
                              <option
                                v-for="item in obj.building_list"
                                :key="item.id"
                              >
                                {{ item.building_name }}({{ item.id }})
                              </option>
                            </datalist>
                            <small>{{ errors.first(`qrCode_${key}`) }}</small>
                          </b-col>
                          <b-col
                            md="3"
                            :class="{ 'form-error': errors.first(`fee_${key}`) }"
                          >
                            <b-form-input
                              v-model.number="items.fee"
                              v-validate="'required'"
                              :min="0"
                              type="number"
                              :name="`fee_${key}`"
                              placeholder="Fee"
                            />
                            <small>{{ errors.first(`fee_${key}`) }}</small>
                          </b-col>
                          <b-col
                            md="1"
                            style="
                          align-self: center;
                          cursor: pointer;
                          color: #3d8bc1;
                        "
                            @click="removeRoomServiceFeeItem(key)"
                          >
                            X
                          </b-col>
                        </b-row>
                        <b-row class="mt-1" style="padding-top: 5px">
                          <b-col>
                            <span
                              style="cursor: pointer; color: #3d8bc1"
                              @click="addRoomServiceFeeItem"
                            >
                              + Add New Item
                            </span>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab ref="print_message_setting" title="Print & Message Setting">
                <b-card-text>
                  <!--
                  <b-row class="typeCheck">
                    <b-col md="2">
                      <label>Message Setting</label>
                    </b-col>
                    <b-col class="mt-1 fl justify-content-start align-items-center">
                      <b-form-checkbox
                        id="order_confirm_message"
                        v-model="order_confirm_message"
                        @change="selectOptions($event, 'order_confirm_message')"
                      />
                      <label for="order_confirm_message">Order Confirmation</label>
                    </b-col>
                  </b-row>
                  -->
                  <b-row>
                    <b-col md="2">
                      <label>Message Filter By Tag</label>
                    </b-col>
                    <b-col md="10">
                      <b-form-radio-group
                        v-model="obj.message_send_type"
                        :options="messageSendTypeOptions"
                        class="form-radio"
                      />
                    </b-col>
                  </b-row>
                  <!--
                  <b-row class="mt-2">
                    <b-col md="2">
                      <label>Print Interval</label>
                    </b-col>
                    <b-col
                      md="3"
                      :class="{ 'form-error': errors.first('printInterval') }"
                    >
                      <b-input-group append="Second">
                        <b-form-input
                          v-model.number="obj.print_interval"
                          v-validate="'required|numeric|minVal:3'"
                          type="number"
                          name="printInterval"
                        />
                      </b-input-group>
                      <small>{{ errors.first('printInterval') }}</small>
                    </b-col>
                  </b-row>
                  -->
                </b-card-text>
              </b-tab>
              <b-tab ref="fee_calculation" title="Merchant Contract & Fee Details">
                <b-card-text>
                  <b-row class="py-3 mx-1 contract-box">
                    <b-col cols="12">
                      <label>Contract Information</label>
                    </b-col>
                    <b-col>
                      <b-row no-gutters>
                        <b-col cols="8">
                          <b-form-file
                            v-model="file"
                            type="file"
                            :disabled="uploading || obj.contracts.length >= maxContracts"
                            placeholder="Upload pdf..."
                            accept="application/pdf"
                            name="file-upload"
                          />
                        </b-col>
                        <b-col cols="2">
                          <b-button
                            class="ml-2"
                            variant="success"
                            :disabled="uploading || !file || obj.contracts.length >= maxContracts"
                            @click.prevent="handleUpload"
                          >
                            <b-spinner v-if="uploading" small /> Upload
                          </b-button>
                        </b-col>
                        <b-col
                          v-if="obj.contracts && obj.contracts.length"
                          cols="12"
                          class="my-3"
                          style="line-height: 38px"
                        >
                          <b-row>
                            <b-col>File Name</b-col>
                            <b-col cols="4">Upload Date</b-col>
                            <b-col cols="2"></b-col>
                          </b-row>
                          <b-row
                            v-for="(item, index) in obj.contracts"
                            :key="`${item.name}_${index}`"
                          >
                            <b-col>{{ item.name }}</b-col>
                            <b-col cols="4">{{ formatDate(item.upload_date) }}</b-col>
                            <b-col cols="2" style="min-width: 115px">
                              <a :href="item.url" download="contract.pdf" target="_blank">Download</a>
                              &nbsp;&nbsp;
                              <a href class="text-danger" @click.prevent="deleteFile(index)">
                                Delete
                              </a>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col cols="auto">
                      <label>Contract Data</label>
                    </b-col>
                    <b-col cols="12" lg="6" class="fl align-items-center justify-content-start">
                      <DateRangePicker
                        ref="dateRangePicker"
                        :start-date="obj.contract_start_date"
                        :end-date="obj.contract_end_date"
                        @update-dates="updateContractDate"
                      />
                      <b-link class="ml-2" style="color: #ff0026;" @click="clearDate">
                        Clear
                      </b-link>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="auto">
                      <label>Merchant Partnership Status</label>
                    </b-col>
                    <b-col cols="12" sm="6" lg="3" class="fl align-items-center">
                      <Multiselect
                        v-model="partnershipStatus"
                        :options="partnershipStatusOptions"
                        :multiple="false"
                        :allow-empty="false"
                        :searchable="false"
                        label="text"
                        track-by="value"
                        deselect-label=""
                        select-label
                        placeholder="Select Status"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="auto">
                      <label>Charged On Total Sales</label>
                    </b-col>
                    <b-col class="mt-1 fl align-items-center">
                      <b-form-checkbox
                        id="charged_on_total_sales"
                        v-model="obj.charged_on_total_sales"
                        :value="1"
                        :unchecked-value="0"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="auto">
                      <label>Order Type Based Fee</label>
                    </b-col>
                    <b-col class="mt-1 fl align-items-center">
                      <b-form-checkbox
                        id="order_type_based_fee_on"
                        v-model="obj.order_type_based_fee_on"
                        :value="1"
                        :unchecked-value="0"
                      />
                    </b-col>
                    <b-col cols="12" class="ml-3">
                      <b-row v-if="obj.order_type_based_fee_on">
                        <b-col cols="12" sm="2" class="mr-2">
                          <label><b>Order Type</b></label>
                        </b-col>
                        <b-col>
                          <b-row
                            v-for="(item, index) in order_type_based_fee"
                            :key="index"
                          >
                            <b-col>
                              <label>{{ item.label }}</label>
                            </b-col>
                            <b-col cols="12" sm="8">
                              <b-row>
                                <b-col cols="auto">
                                  <label>Fee</label>
                                </b-col>
                                <b-col cols="10" lg="8">
                                  <b-input-group append="%">
                                    <b-form-input
                                      v-model.number="item.value"
                                      type="number"
                                      step="0.01"
                                    />
                                  </b-input-group>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="auto">
                      <label>Payment Method Based Fee</label>
                    </b-col>
                    <b-col class="mt-1 fl align-items-center">
                      <b-form-checkbox
                        id="payment_method_based_fee_on"
                        v-model="obj.payment_method_based_fee_on"
                        :value="1"
                        :unchecked-value="0"
                      />
                    </b-col>
                    <b-col cols="12" class="ml-3">
                      <template v-if="obj.payment_method_based_fee_on">
                        <b-row>
                          <b-col cols="12" sm="2" class="mr-2">
                            <label><b>Basic Rate</b></label>
                          </b-col>
                          <b-col>
                            <b-row
                              v-for="(item, index) in payment_method_based_fee"
                              :key="index"
                            >
                              <b-col>
                                <label>{{ item.label }}</label>
                              </b-col>
                              <b-col cols="12" sm="8">
                                <b-row>
                                  <b-col cols="auto">
                                    <label>Fee</label>
                                  </b-col>
                                  <b-col cols="10" lg="8">
                                    <b-input-group append="%">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="0.01"
                                      />
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" sm="2" class="mr-2">
                            <label><b>Discount</b></label>
                          </b-col>
                          <b-col>
                            <b-row
                              v-for="(item, index) in payment_method_discount_fee"
                              :key="index"
                            >
                              <b-col>
                                <label>{{ item.label }}</label>
                              </b-col>
                              <b-col cols="12" sm="8">
                                <b-row>
                                  <b-col cols="auto">
                                    <label>Fee</label>
                                  </b-col>
                                  <b-col cols="10" lg="8">
                                    <b-input-group append="%">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="0.01"
                                      />
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </template>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="auto">
                      <label>Member VIP Fee</label>
                    </b-col>
                    <b-col class="mt-1 fl align-items-center">
                      <b-form-checkbox
                        id="others_fee_on"
                        v-model="obj.others_fee_on"
                        :value="1"
                        :unchecked-value="0"
                      />
                    </b-col>
                    <b-col cols="12" class="ml-3">
                      <template v-if="obj.others_fee_on">
                        <b-row>
                          <b-col cols="12" sm="2" class="mr-2">
                            <label><b>Basic Rate</b></label>
                          </b-col>
                          <b-col>
                            <b-row
                              v-for="(item, index) in others_based_fee"
                              :key="index"
                            >
                              <b-col>
                                <label>{{ item.label }}</label>
                              </b-col>
                              <b-col cols="12" sm="8">
                                <b-row>
                                  <b-col v-if="item.isFee" cols="auto">
                                    <label>Fee</label>
                                  </b-col>
                                  <b-col cols="10" lg="8">
                                    <b-input-group v-if="item.type === 'price'" prepend="Rp">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="1"
                                      />
                                    </b-input-group>
                                    <b-form-checkbox v-else-if="item.type === 'checkbox'" v-model="item.value" class="form-checkbox" />
                                    <b-input-group v-else append="%">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="0.01"
                                      />
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" sm="2" class="mr-2">
                            <label><b>Discount</b></label>
                          </b-col>
                          <b-col>
                            <b-row
                              v-for="(item, index) in others_discount_fee"
                              :key="index"
                            >
                              <b-col>
                                <label>{{ item.label }}</label>
                              </b-col>
                              <b-col cols="12" sm="8">
                                <b-row>
                                  <b-col v-if="item.isFee" cols="auto">
                                    <label>Fee</label>
                                  </b-col>
                                  <b-col cols="10" lg="8">
                                    <b-input-group v-if="item.type === 'price'" prepend="Rp">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="1"
                                      />
                                    </b-input-group>
                                    <b-form-checkbox v-else-if="item.type === 'checkbox'" v-model="item.value" class="form-checkbox" />
                                    <b-input-group v-else append="%">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="0.01"
                                      />
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </template>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="auto">
                      <label>Monthly Fee</label>
                    </b-col>
                    <b-col class="mt-1 fl align-items-center">
                      <b-form-checkbox
                        id="monthly_fee_on"
                        v-model="obj.monthly_fee_on"
                        :value="1"
                        :unchecked-value="0"
                      />
                    </b-col>
                    <b-col cols="12" class="ml-3">
                      <template v-if="obj.monthly_fee_on">
                        <b-row>
                          <b-col cols="12" sm="2" class="mr-2">
                            <label><b>Basic Rate</b></label>
                          </b-col>
                          <b-col>
                            <b-row
                              v-for="(item, index) in monthly_based_fee"
                              :key="index"
                              :class="item.isSub ? 'pl-3' : ''"
                            >
                              <b-col>
                                <label>{{ item.label }}</label>
                              </b-col>
                              <b-col cols="12" sm="8">
                                <b-row>
                                  <b-col v-if="item.isFee" cols="auto">
                                    <label>Fee</label>
                                  </b-col>
                                  <b-col cols="10" lg="8">
                                    <b-input-group v-if="item.type === 'price'" prepend="Rp">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="1"
                                      />
                                    </b-input-group>
                                    <b-form-checkbox v-else-if="item.type === 'checkbox'" v-model="item.value" class="form-checkbox" />
                                    <b-input-group v-else append="%">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="0.01"
                                      />
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" sm="2" class="mr-2">
                            <label><b>Discount</b></label>
                          </b-col>
                          <b-col>
                            <b-row
                              v-for="(item, index) in monthly_discount_fee"
                              :key="index"
                              :class="item.isSub ? 'pl-3' : ''"
                            >
                              <b-col>
                                <label>{{ item.label }}</label>
                              </b-col>
                              <b-col cols="12" sm="8">
                                <b-row>
                                  <b-col v-if="item.isFee" cols="auto">
                                    <label>Fee</label>
                                  </b-col>
                                  <b-col cols="10" lg="8">
                                    <b-input-group v-if="item.type === 'price'" prepend="Rp">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="1"
                                      />
                                    </b-input-group>
                                    <b-form-checkbox v-else-if="item.type === 'checkbox'" v-model="item.value" class="form-checkbox" />
                                    <b-input-group v-else append="%">
                                      <b-form-input
                                        v-model.number="item.value"
                                        type="number"
                                        step="0.01"
                                      />
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </template>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success" :disabled="isAddEdit">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />
            Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style lang="scss" scoped>
@import 'style';
</style>

<script>
import OttoPaySettings from '@/components/OttoPaySettings.vue'
import moment from 'moment-timezone'
import _ from 'lodash'
import Multiselect from 'vue-multiselect';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faSave, faTimes } from '@fortawesome/free-solid-svg-icons'
import {
  getFileName,
  getFileNameWithUUID,
  getResponseToMTHForNewPort
} from '@/utils/helpers'
import constants from '@/utils/constants'
import {
  DefaultOrderTypeBased,
  DefaultPaymentMethodBased,
  DefaultOthersBased,
  DefaultMonthlyBased,
} from '@/utils/feeConstant'
import { firebaseApp, firebaseStorage } from '@/firebase'
import DateRangePicker from '@/components/DateRangePicker.vue';

library.add(faBars, faSave, faTimes)

const DefaultObj = {
  id: '',
  outlet_code: '',
  name: '',
  address: '',
  phone_number: '',
  tax_percentage: 0.0,
  restaurant_tax: 0.0,
  delivery_charge: 0.0,
  area_code: '',
  area_name: '',
  city_code: '',
  city_name: '',
  is_active: false,
  latitude: 0.0,
  longitude: 0.0,
  is_open24_hours: false,
  is_test_mode: false,
  edc_model: false,
  min_charge: 0.0,
  delivery_fee: [],
  building_fee: [],
  whats_app_id: '',
  delivery_type: '',
  order_types: [],
  delivery_max_range: 0,
  type: '',
  service_fee: {},
  half_menu_cal_rate: 1.155,
  value_added_tax: {},
  processing_fee: {},
  payment_order: '',
  total_rounding_type: 0,
  total_rounding_value: 0,
  is_exclude_fee_taxable: 0,
  only_dine_in: 0,
  order_state_machine: 0,
  is_pos_input: 0,
  bo_auto_completed: 0,
  pos_active: 0, // Receipt Number input
  pos_name: '',
  pos_order_required: 0, // Receipt Number input mandatory
  payment_method: 'Midtrans',
  cimb_terminal_id: '',
  cimb_merchant_id: '',
  qdo_astrapay_payment: 0,
  bo_astrapay_payment: 0,
  print_interval: constants.PRINT_INTERVAL,
  charged_on_total_sales: 0,
  order_type_based_fee_on: 0,
  payment_method_based_fee_on: 0,
  others_fee_on: 0,
  monthly_fee_on: 0,
  contracts: [],
  edc_qris: 1,
  edc_online_payment: constants.EDC_ONLINE_PAYMENT,
  edc_cimb_payment: constants.EDC_CIMB_PAYMENT,
  edc_offline_payment: {
    ...constants.EDC_OFFLINE_PAYMENT,
    cash: 1,
  },
  merchant_partnership_status: 0,
  contract_start_date: '',
  contract_end_date: '',
  edc_order_flow_type: 0,
  message_send_type: 0,
  phone_input_required: 0,
  brand_new_customer_treatment: 0,
}
const TabsList = [
  'outlet_info',
  'order_setting',
  'payment_setting',
  'delivery_setting',
  'print_message_setting',
  'fee_calculation'
]
const partnershipStatusOptions = [
  { text: 'None', value: 0 },
  { text: 'Active', value: 1 },
  { text: 'Churned', value: 2 },
  { text: 'Hold', value: 3 }
];

export default {
  components: {
    OttoPaySettings,
    Multiselect,
    DateRangePicker,
  },
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 0,
      obj: _.cloneDeep(DefaultObj),
      edcOfflinePaymentOptions: constants.EDC_OFFLINE_PAYMENT_OPTIONS,
      onlyDineInOptions: [{ text: 'Yes', value: 1 }, { text: 'No', value: 0 }],
      orderStateMachineOptions: [
        { text: 'Yes', value: 0 },
        { text: 'No', value: 1 }
      ],
      posInputOptions: [{ text: 'Yes', value: 1 }, { text: 'No', value: 0 }],
      edcQRISOptions: constants.Y_OR_N_OPTIONS,
      boAutoCompletedOptions: [
        { text: 'Yes', value: 1 },
        { text: 'No', value: 0 }
      ],
      paymentMethodOptions: [
        { text: 'CIMB', value: 'CIMB' },
        { text: 'Midtrans', value: 'Midtrans' },
        { text: 'AstraPay', value: 'Astrapay' }
      ],
      partnershipStatusOptions: partnershipStatusOptions,
      userType: this.$store.state.currentUser
        ? this.$store.state.currentUser.Type
        : '',
      checkoutBoxStatus: true,
      orderTakeaway: false,
      orderDelivery: false,
      dineInStatus: false,
      roomServiceStatus: false,
      tableOrder: false,
      deliveryMethod: false,
      qsrTableNumber: true,
      isOrderType: false,
      beforeOrderMade: true,
      afterOrderMade: false,
      fsrTableNumber: false,
      isMethodShow: false,
      isRoomServiceFeeShow: false,
      isAddEdit: true,
      farthestDistance: [],
      maxDistance: 0,
      isServiceChargeShow: false,
      serviceCharge: null,
      takeAwayVat: null,
      takeAwayFee: 0,
      deliveryVat: null,
      deliveryFee: 0,
      dineInVat: null,
      dineInFee: 0,
      roomServiceVat: null,
      roomServiceFee: 0,
      tableOrderVat: null,
      tableOrderFee: 0,
      isPaymentOrderShow: false,
      showRoomService: false,
      orderOthers: false,
      orderPos: false,
      othersFee: 0,
      posFee: 0,
      edc_payment_new_flow: false,
      qdo_offline_payment: false,
      bo_offline_payment: false,
      order_confirm_message: true,
      file: null,
      uploading: false,
      order_type_based_fee: [],
      payment_method_based_fee: [],
      payment_method_discount_fee: [],
      others_based_fee: [],
      others_discount_fee: [],
      monthly_based_fee: [],
      monthly_discount_fee: [],
      maxContracts: constants.MAX_CONTRACTS,
      edcOrderFlowOptions: constants.EDC_ORDER_FLOW,
      partnershipStatus: partnershipStatusOptions[0],
      messageSendTypeOptions: constants.MESSAGE_SEND_TYPE,
    }
  },
  computed: {
    syncRestaurantDetail: function() {
      return this.$store.getters.GetSyncRestaurant
    },
    checkEdcOrderFlowRole: function() {
      return ['Admin', 'Merchant OPS'].includes(
        this.$store.state.currentUser.Type
      );
    }
  },
  watch: {
    syncRestaurantDetail: {
      handler(val) {
        if (val.error) {
          this.$swal(
            constants.SOMETHING_WROING,
            val.error,
            constants.STATUS_ERROR
          )
        }
        if (val.data) {
          this.obj = {
            ...this.obj,
            name: val.data.title,
            address: val.data.address,
            phone_number: val.data.phone,
            area_code: val.data.district_id
              ? val.data.district_id.toString()
              : '',
            area_name: val.data.district_name,
            city_code: val.data.city_id ? val.data.city_id.toString() : '',
            city_name: val.data.city_name,
            latitude: val.data.latitude,
            longitude: val.data.longitude,
            whats_app_id: val.data.whatsAppID,
            total_rounding_value: val.data.total_rounding_value,
            total_rounding_type: val.data.total_rounding_type,
            is_exclude_fee_taxable: val.data.is_exclude_fee_taxable,
            only_dine_in: val.data.only_dine_in,
            order_state_machine: val.data.order_state_machine,
            is_pos_input: val.data.is_pos_input,
            bo_auto_completed: val.data.bo_auto_completed,
            pos_active: val.data.pos_active,
            pos_name: val.data.pos_name,
            pos_order_required: val.data.pos_order_required,
            payment_method: val.payment_method
              ? val.payment_method
              : val.cimb_terminal_id
                ? 'CIMB'
                : 'Midtrans',
            cimb_merchant_id: val.data.cimb_merchant_id,
            cimb_terminal_id: val.data.cimb_terminal_id,
            edc_order_flow_type: val.data.edc_order_flow_type || 0,
            message_send_type: val.data.message_send_type || 0,
            phone_input_required: val.data.phone_input_required || 0,
            brand_new_customer_treatment: val.data.brand_new_customer_treatment || 0,
          }
        }
      },
      deep: true
    },
    roomServiceStatus: {
      handler(val) {
        this.isRoomServiceFeeShow = val
        if (val) {
          this.isPaymentOrderShow = true
        } else {
          if (this.tableOrder) return
          this.isPaymentOrderShow = false
        }
      }
    },
    'obj.outlet_code': {
      handler(val) {
        const cloneObj = _.cloneDeep(this.obj)
        let validOutLet = []
        if (this.obj.is_pos_input !== 0) {
          validOutLet.push(val)
        }
        this.showRoomService = validOutLet.length !== 0
        if (!this.showRoomService) {
          this.roomServiceStatus = false
          this.roomServiceVat = null
          const indexOfRoomService = cloneObj.order_types.indexOf(
            constants.ROOM
          )
          if (indexOfRoomService > -1) {
            cloneObj.order_types.splice(indexOfRoomService, 1)
          }
          this.obj = cloneObj
        }
      }
    },
    obj: {
      handler(val) {
        this.obj.total_rounding_value = val.total_rounding_value || 0
        this.obj.total_rounding_type = val.total_rounding_type || 0
        this.obj.is_exclude_fee_taxable = val.is_exclude_fee_taxable || 0
        this.obj.only_dine_in = val.only_dine_in || 0
        this.obj.order_state_machine = val.order_state_machine || 0
        this.obj.is_pos_input = val.is_pos_input || 0
        this.obj.bo_auto_completed = val.bo_auto_completed || 0
        this.obj.pos_active = val.pos_active || 0
        this.obj.pos_name = val.pos_name || ''
        this.obj.pos_order_required = val.pos_order_required || 0
        this.obj.payment_method = val.payment_method
          ? val.payment_method
          : val.cimb_terminal_id
            ? 'CIMB'
            : 'Midtrans'
        this.obj.cimb_terminal_id = val.cimb_terminal_id || ''
        this.obj.cimb_merchant_id = val.cimb_merchant_id || ''
        this.obj.building_fee = val.building_fee || []
        this.obj.edc_payment_new_flow = val.edc_payment_new_flow || 0
        this.obj.qdo_offline_payment = val.qdo_offline_payment || 0
        this.obj.bo_offline_payment = val.bo_offline_payment || 0
        this.obj.order_confirm_message = val.order_confirm_message || 0
        this.obj.contracts = val.contracts || []
        this.obj.edc_order_flow_type = val.edc_order_flow_type || 0
        this.obj.message_send_type = val.message_send_type || 0
        this.obj.phone_input_required = val.phone_input_required || 0
        this.obj.brand_new_customer_treatment = val.brand_new_customer_treatment || 0
        if (
          this.isMethodShow &&
          this.checkoutBoxStatus &&
          val.delivery_fee.length === 0
        ) {
          this.isAddEdit = true
        } else {
          this.isAddEdit = false
        }
        if (val.order_types.length !== 0) {
          this.isOrderType = false
        }
        this.edc_payment_new_flow = !!this.obj.edc_payment_new_flow
        this.qdo_offline_payment = !!this.obj.qdo_offline_payment
        this.bo_offline_payment = !!this.obj.bo_offline_payment
        this.order_confirm_message = !!this.obj.order_confirm_message
        if (val.merchant_partnership_status >= 0) {
          this.partnershipStatus = partnershipStatusOptions.find(
            item => item.value === val.merchant_partnership_status
          )
        }
      },
      deep: true
    },
    dineInStatus: {
      handler(val) {
        if (val) {
          this.isServiceChargeShow = true
        } else {
          this.isServiceChargeShow = false
          this.obj.service_fee = {}
        }
      }
    },
    tableOrder: {
      handler(val) {
        if (val) {
          this.isServiceChargeShow = true
          this.isPaymentOrderShow = true
        } else {
          this.isServiceChargeShow = false
          this.obj.service_fee = {}
          if (this.isRoomServiceFeeShow) return
          this.isPaymentOrderShow = false
        }
      }
    },
    partnershipStatus: {
      handler(val) {
        if (val) {
          this.obj.merchant_partnership_status = val.value
        } else {
          this.obj.merchant_partnership_status = 0
        }
      }
    }
  },

  mounted() {
    this.checkOrderType()
  },

  methods: {
    formatDate(val) {
      let date = val
      if (moment(date).isValid()) {
        date = moment(date).format('MMMM DD, YYYY')
      }
      return date
    },
    selectIsExcludeFeeTaxable() {
      this.obj.is_exclude_fee_taxable = this.obj.is_exclude_fee_taxable ? 0 : 1
    },
    changeTotalRoundingType(e) {
      const obj = _.cloneDeep(this.obj)
      if (e) {
        obj.total_rounding_type = 1
        obj.total_rounding_value = 10
      } else {
        obj.total_rounding_type = 0
        obj.total_rounding_value = 0
      }
      this.obj = obj
    },
    updateContractDate(date) {
      this.obj.contract_start_date = date.startDate
      this.obj.contract_end_date = date.endDate
    },
    clearDate() {
      this.$refs.dateRangePicker.resetDate();
    },
    // add and update records
    saveStore() {
      for (let i = 0; i < this.obj.building_fee.length; i++) {
        const element = this.obj.building_fee[i]
        if (element && element.selected) {
          element.id = element.selected.id
          delete element.selected
        }
      }
      this.$validator.validate().then(valid => {
        if (valid) {
          this.obj.delivery_fee = _.sortBy(
            _.uniqBy(this.obj.delivery_fee, 'distance'),
            'distance'
          )
          if (this.qsrTableNumber) {
            this.obj.type = 'QSR'
          } else {
            this.obj.type = 'FSR'
          }
          this.checkServiceCharge()
          this.checkPaymentOrder()
          this.checkFee()
          this.obj.half_menu_cal_rate = Number(this.obj.half_menu_cal_rate)
          if (this.input === null) {
            if (this.obj.order_types.length === 0) {
              this.isOrderType = true
            } else {
              this.$store
                .dispatch('CreateStoreForNewPort', this.obj)
                .then(response => {
                  let res = getResponseToMTHForNewPort(
                    response,
                    this.$swal,
                    constants.RECORD_IS_CREATED
                  )
                  if (res) {
                    this.$emit('discard-modal', true)
                    this.reset()
                  }
                })
                .catch(error => {
                  this.$swal(
                    constants.SOMETHING_WROING,
                    error,
                    constants.STATUS_ERROR
                  )
                })
            }
          } else {
            if (this.obj.order_types.length === 0) {
              this.isOrderType = true
            } else {
              delete this.obj.zip_code
              delete this.obj.region_code
              delete this.obj.fax_number
              this.$store
                .dispatch('UpdateStoreForNewPort', this.obj)
                .then(response => {
                  let res = getResponseToMTHForNewPort(
                    response,
                    this.$swal,
                    constants.RECORD_IS_UPDATED
                  )
                  if (res) {
                    this.$emit('discard-modal', true)
                    this.reset()
                  }
                })
                .catch(error => {
                  this.$swal(
                    constants.SOMETHING_WROING,
                    error,
                    constants.STATUS_ERROR
                  )
                })
            }
          }
        } else {
          this.checkTabError()
        }
      })
    },

    checkTabError() {
      for (let [i, v] of TabsList.entries()) {
        if (this.$refs[v]) {
          const errors = this.$refs[v].$el.getElementsByClassName('form-error')
          if (errors && errors.length) {
            this.activeTab = i
            setTimeout(() => {
              errors[0].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
              })
            })
            break
          }
        }
      }
    },

    checkServiceCharge() {
      this.obj.value_added_tax = {}
      this.obj.processing_fee = {}
      if (this.dineInStatus) {
        this.obj.service_fee = {
          PPDI: Number(this.serviceCharge)
        }
      } else if (this.tableOrder) {
        this.obj.service_fee = {
          TOP: Number(this.serviceCharge)
        }
      }
      if (this.orderTakeaway) {
        this.obj.value_added_tax.PPTA = Number(this.takeAwayVat)
        this.obj.processing_fee.PPTA = Number(this.takeAwayFee)
      }
      if (this.orderDelivery) {
        this.obj.value_added_tax.HMD = Number(this.deliveryVat)
        this.obj.processing_fee.HMD = Number(this.deliveryFee)
      }
      if (this.dineInStatus) {
        this.obj.value_added_tax.PPDI = Number(this.dineInVat)
        this.obj.processing_fee.PPDI = Number(this.dineInFee)
      }
      if (this.tableOrder) {
        this.obj.value_added_tax.TOP = Number(this.tableOrderVat)
        this.obj.processing_fee.TOP = Number(this.tableOrderFee)
      }
      if (this.roomServiceStatus) {
        this.obj.value_added_tax.ROOM = Number(this.roomServiceVat)
        this.obj.processing_fee.ROOM = Number(this.roomServiceFee)
      }

      if (this.orderOthers) {
        this.obj.processing_fee.OTHERS = Number(this.othersFee)
      }

      if (this.orderPos) {
        this.obj.processing_fee.POS = Number(this.posFee)
      }
    },

    checkOrderType() {
      if (this.input) {
        this.input.order_types.map(item => {
          if (item === constants.PPTA) {
            this.orderTakeaway = true
          }
          if (item === constants.HMD) {
            this.orderDelivery = true
            this.isMethodShow = true
          }
          if (item === constants.PPDI) {
            this.dineInStatus = true
          }
          if (item === constants.TOP) {
            this.tableOrder = true
          }
          if (item === constants.ROOM) {
            this.roomServiceStatus = true
          }

          if (
            item === constants.OTHERS &&
            this.input.processing_fee.OTHERS !== undefined
          ) {
            this.orderOthers = true
          }

          if (
            item === constants.POS &&
            this.input.processing_fee.POS !== undefined
          ) {
            this.orderPos = true
          }
        })

        if (this.input.delivery_type === 'mrspeedy') {
          this.deliveryMethod = true
          this.checkoutBoxStatus = false
          this.maxDistance = this.input.delivery_max_range
        }
        if (this.input.type === 'QSR') {
          this.qsrTableNumber = true
          this.tableOrder = false
        } else if (this.input.type === 'FSR') {
          this.dineInStatus = false
          this.qsrTableNumber = false
          this.fsrTableNumber = true
        }
        if (this.input.service_fee) {
          if (
            this.input.service_fee.PPDI ||
            this.input.service_fee.PPDI === 0
          ) {
            this.serviceCharge = this.input.service_fee.PPDI
          }
          if (this.input.service_fee.TOP || this.input.service_fee.TOP === 0) {
            this.serviceCharge = this.input.service_fee.TOP
          }
        }
        if (this.input.value_added_tax) {
          if (
            this.input.value_added_tax.HMD ||
            this.input.value_added_tax.HMD === 0
          ) {
            this.deliveryVat = this.input.value_added_tax.HMD
          }
          if (
            this.input.value_added_tax.TOP ||
            this.input.value_added_tax.TOP === 0
          ) {
            this.tableOrderVat = this.input.value_added_tax.TOP
          }
          if (
            this.input.value_added_tax.PPDI ||
            this.input.value_added_tax.PPDI === 0
          ) {
            this.dineInVat = this.input.value_added_tax.PPDI
          }
          if (
            this.input.value_added_tax.PPTA ||
            this.input.value_added_tax.PPTA === 0
          ) {
            this.takeAwayVat = this.input.value_added_tax.PPTA
          }
          if (
            this.input.value_added_tax.ROOM ||
            this.input.value_added_tax.ROOM === 0
          ) {
            this.roomServiceVat = this.input.value_added_tax.ROOM
          }
        }
        if (this.input.processing_fee) {
          if (
            this.input.processing_fee.HMD ||
            this.input.processing_fee.HMD === 0
          ) {
            this.deliveryFee = this.input.processing_fee.HMD
          }
          if (
            this.input.processing_fee.TOP ||
            this.input.processing_fee.TOP === 0
          ) {
            this.tableOrderFee = this.input.processing_fee.TOP
          }
          if (
            this.input.processing_fee.PPDI ||
            this.input.processing_fee.PPDI === 0
          ) {
            this.dineInFee = this.input.processing_fee.PPDI
          }
          if (
            this.input.processing_fee.PPTA ||
            this.input.processing_fee.PPTA === 0
          ) {
            this.takeAwayFee = this.input.processing_fee.PPTA
          }
          if (
            this.input.processing_fee.ROOM ||
            this.input.processing_fee.ROOM === 0
          ) {
            this.roomServiceFee = this.input.processing_fee.ROOM
          }
          if (
            this.input.processing_fee.OTHERS ||
            this.input.processing_fee.OTHERS === 0
          ) {
            this.othersFee = this.input.processing_fee.OTHERS
          }
          if (
            this.input.processing_fee.POS ||
            this.input.processing_fee.POS === 0
          ) {
            this.posFee = this.input.processing_fee.POS
          }
        }
        if (this.input.payment_order === 'post_pay') {
          this.afterOrderMade = true
          this.beforeOrderMade = false
        } else if (this.input.payment_order === 'pre_pay') {
          this.beforeOrderMade = true
          this.afterOrderMade = false
        }
      }
      if (this.isMethodShow && this.checkoutBoxStatus) {
        if (this.input.delivery_fee.length === 0) {
          this.isAddEdit = true
        } else {
          this.isAddEdit = false
        }
      }
      if (!this.input.edc_qris) {
        this.input.edc_qris = 0
      }
      if (!this.input.edc_online_payment || _.isEmpty(this.input.edc_online_payment)) {
        this.input.edc_online_payment = constants.EDC_ONLINE_PAYMENT
      }
      if (!this.input.edc_cimb_payment || _.isEmpty(this.input.edc_cimb_payment)) {
        this.input.edc_cimb_payment = constants.EDC_CIMB_PAYMENT
      }
      if (!this.input.edc_offline_payment || _.isEmpty(this.input.edc_offline_payment)) {
        this.input.edc_offline_payment = constants.EDC_OFFLINE_PAYMENT
      }
    },

    checkPaymentOrder() {
      if ((this.tableOrder || this.roomServiceStatus) && this.beforeOrderMade) {
        this.obj.payment_order = 'pre_pay'
      } else if (
        (this.tableOrder || this.roomServiceStatus) &&
        this.afterOrderMade
      ) {
        this.obj.payment_order = 'post_pay'
      } else {
        this.obj.payment_order = ''
      }
    },

    checkFee() {
      this.obj.order_type_based_fee = this.obj.order_type_based_fee_on
        ? JSON.stringify(
            _.mapValues(_.keyBy(this.order_type_based_fee, 'id'), 'value')
          )
        : ''
      this.obj.payment_method_based_fee = this.obj.payment_method_based_fee_on
        ? JSON.stringify(
            _.mapValues(_.keyBy(this.payment_method_based_fee, 'id'), 'value')
          )
        : ''
      this.obj.payment_method_discount_fee = this.obj
        .payment_method_based_fee_on
        ? JSON.stringify(
            _.mapValues(
              _.keyBy(this.payment_method_discount_fee, 'id'),
              'value'
            )
          )
        : ''
      this.obj.others_based_fee = this.obj.others_fee_on
        ? JSON.stringify(
            _.mapValues(_.keyBy(this.others_based_fee, 'id'), 'value')
          )
        : ''
      this.obj.others_discount_fee = this.obj.others_fee_on
        ? JSON.stringify(
            _.mapValues(_.keyBy(this.others_discount_fee, 'id'), 'value')
          )
        : ''
      this.obj.monthly_based_fee = this.obj.monthly_fee_on
        ? JSON.stringify(
            _.mapValues(_.keyBy(this.monthly_based_fee, 'id'), 'value')
          )
        : ''
      this.obj.monthly_discount_fee = this.obj.monthly_fee_on
        ? JSON.stringify(
            _.mapValues(_.keyBy(this.monthly_discount_fee, 'id'), 'value')
          )
        : ''
    },

    formatFeeData() {
      if (this.obj.order_type_based_fee) {
        const order_type_based_obj = JSON.parse(this.obj.order_type_based_fee)
        this.order_type_based_fee = DefaultOrderTypeBased.map(v => ({
          ...v,
          value: order_type_based_obj[v.id] || 0
        }))
      } else {
        this.order_type_based_fee = _.cloneDeep(DefaultOrderTypeBased)
      }
      if (this.obj.payment_method_based_fee) {
        const payment_method_based_obj = JSON.parse(
          this.obj.payment_method_based_fee
        )
        this.payment_method_based_fee = DefaultPaymentMethodBased.map(v => ({
          ...v,
          value: payment_method_based_obj[v.id] || 0
        }))
      } else {
        this.payment_method_based_fee = _.cloneDeep(DefaultPaymentMethodBased)
      }
      if (this.obj.payment_method_discount_fee) {
        const payment_method_discount_obj = JSON.parse(
          this.obj.payment_method_discount_fee
        )
        this.payment_method_discount_fee = DefaultPaymentMethodBased.map(v => ({
          ...v,
          value: payment_method_discount_obj[v.id] || 0
        }))
      } else {
        this.payment_method_discount_fee = _.cloneDeep(
          DefaultPaymentMethodBased
        )
      }
      if (this.obj.others_based_fee) {
        const others_based_obj = JSON.parse(this.obj.others_based_fee)
        this.others_based_fee = DefaultOthersBased.map(v => ({
          ...v,
          value: others_based_obj[v.id] || 0
        }))
      } else {
        this.others_based_fee = _.cloneDeep(DefaultOthersBased)
      }
      if (this.obj.others_discount_fee) {
        const others_discount_obj = JSON.parse(this.obj.others_discount_fee)
        this.others_discount_fee = DefaultOthersBased.map(v => ({
          ...v,
          value: others_discount_obj[v.id] || 0
        }))
      } else {
        this.others_discount_fee = _.cloneDeep(DefaultOthersBased)
      }
      if (this.obj.monthly_based_fee) {
        const monthly_based_obj = JSON.parse(this.obj.monthly_based_fee)
        this.monthly_based_fee = DefaultMonthlyBased.map(v => ({
          ...v,
          value: monthly_based_obj[v.id] || 0
        }))
      } else {
        this.monthly_based_fee = _.cloneDeep(DefaultMonthlyBased)
      }
      if (this.obj.monthly_discount_fee) {
        const monthly_discount_obj = JSON.parse(this.obj.monthly_discount_fee)
        this.monthly_discount_fee = DefaultMonthlyBased.map(v => ({
          ...v,
          value: monthly_discount_obj[v.id] || 0
        }))
      } else {
        this.monthly_discount_fee = _.cloneDeep(DefaultMonthlyBased)
      }
    },

    discardModal() {
      this.reset()
      this.$emit('discard-modal')
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = _.cloneDeep(DefaultObj)
        this.order_type_based_fee = _.cloneDeep(DefaultOrderTypeBased)
        this.payment_method_based_fee = _.cloneDeep(DefaultPaymentMethodBased)
        this.payment_method_discount_fee = _.cloneDeep(
          DefaultPaymentMethodBased
        )
        this.others_based_fee = _.cloneDeep(DefaultOthersBased)
        this.others_discount_fee = _.cloneDeep(DefaultOthersBased)
        this.monthly_based_fee = _.cloneDeep(DefaultMonthlyBased)
        this.monthly_discount_fee = _.cloneDeep(DefaultMonthlyBased)
      } else {
        this.obj = {
          ..._.cloneDeep(DefaultObj),
          ..._.cloneDeep(this.input)
        }
        this.formatFeeData()
      }
    },

    restaurantSync() {
      this.$store.dispatch('CheckStore', {
        outletCode: this.obj.outlet_code,
        needCheck: !this.input
      })
    },

    addDeliveryFeeItem() {
      this.isAddEdit = false
      this.obj.delivery_fee.push({
        distance: '',
        orderValue: '',
        price: ''
      })
    },
    addRoomServiceFeeItem() {
      this.isAddEdit = false
      const cloneObj = _.cloneDeep(this.obj)
      cloneObj.building_fee.push({
        fee: '',
        building_name: '',
        id: ''
      })
      this.obj = cloneObj
    },

    changeDistance() {
      this.obj.delivery_max_range = this.maxDistance
    },

    selectQsrTable(e) {
      this.resetStatus()
      if (e) {
        this.fsrTableNumber = false
      } else {
        this.fsrTableNumber = true
      }
    },

    selectFsrTable(e) {
      this.resetStatus()
      if (e) {
        this.qsrTableNumber = false
      } else {
        this.qsrTableNumber = true
      }
    },

    resetStatus() {
      this.orderTakeaway = false
      this.orderDelivery = false
      this.tableOrder = false
      this.dineInStatus = false
      this.roomServiceStatus = false
      this.orderOthers = false
      this.orderPos = false
      this.obj.order_types = []
    },

    removeDeliveryFeeItem(key) {
      this.obj.delivery_fee.splice(key, 1)
    },
    removeRoomServiceFeeItem(key) {
      this.obj.building_fee.splice(key, 1)
    },
    changeQr(e, item) {
      const id = e
        .substring(e.lastIndexOf('('))
        .replace('(', '')
        .replace(')', '')
      const selected =
        this.obj.building_list.filter(item => item.id === Number(id))[0] || {}
      item.selected = selected
    },
    changeOutletStatus(checked) {
      if (checked) {
        this.obj.delivery_type = ''
        this.deliveryMethod = false
      } else {
        this.deliveryMethod = true
      }
      this.obj.delivery_fee = _.sortBy(
        _.uniqBy(this.obj.delivery_fee, 'distance'),
        'distance'
      )
    },

    selectDeliveryMethod(checked) {
      this.isAddEdit = false
      if (checked) {
        this.obj.delivery_type = 'mrspeedy'
        this.checkoutBoxStatus = false
      } else {
        this.obj.delivery_type = ''
        this.checkoutBoxStatus = true
      }
    },

    selectTakeAway(e) {
      if (e) {
        this.obj.order_types.push(constants.PPTA)
        this.isAddEdit = false
      } else {
        this.obj.order_types.splice(
          this.obj.order_types.indexOf(constants.PPTA),
          1
        )
      }
    },

    selectDelivery(e) {
      if (e) {
        this.obj.order_types.push(constants.HMD)
        this.isMethodShow = true
      } else {
        this.isAddEdit = false
        this.obj.order_types.splice(
          this.obj.order_types.indexOf(constants.HMD),
          1
        )
        this.isMethodShow = false
      }
    },

    selectDineIn(e) {
      if (e) {
        this.obj.order_types.push(constants.PPDI)
        this.isAddEdit = false
      } else {
        this.obj.order_types.splice(
          this.obj.order_types.indexOf(constants.PPDI),
          1
        )
      }
    },
    selectRoomService(e) {
      this.isAddEdit = e
      this.roomServiceStatus = e
      if (e) {
        this.obj.order_types.push(constants.ROOM)
        this.obj.building_fee = []
      } else {
        this.obj.order_types.splice(
          this.obj.order_types.indexOf(constants.ROOM),
          1
        )
      }
    },

    selectTableOrder(e) {
      if (e) {
        this.obj.order_types.push(constants.TOP)
        this.isAddEdit = false
      } else {
        this.obj.order_types.splice(
          this.obj.order_types.indexOf(constants.TOP),
          1
        )
      }
    },

    selectOthersOrder(e) {
      if (e) {
        this.obj.order_types.push(constants.OTHERS)
        this.isAddEdit = false
      } else {
        this.obj.order_types.splice(
          this.obj.order_types.indexOf(constants.OTHERS),
          1
        )
      }
    },

    selectPosOrder(e) {
      if (e) {
        this.obj.order_types.push(constants.POS)
        this.isAddEdit = false
      } else {
        this.obj.order_types.splice(
          this.obj.order_types.indexOf(constants.POS),
          1
        )
      }
    },

    changeBeforeMader(e) {
      if (e) {
        this.afterOrderMade = false
        this.beforeOrderMade = true
      } else {
        this.beforeOrderMade = false
        this.afterOrderMade = true
      }
    },

    changeAfterMade(e) {
      if (e) {
        this.beforeOrderMade = false
        this.afterOrderMade = true
      } else {
        this.afterOrderMade = false
        this.beforeOrderMade = true
      }
    },

    selectOptions(e, key) {
      if (e) {
        this.obj[key] = 1
      } else {
        this.obj[key] = 0
      }
    },

    deleteFile(index) {
      this.obj.contracts = this.obj.contracts.filter((_, i) => i !== index)
    },

    handleUpload() {
      this.uploading = true
      try {
        let fullPath, created
        const name = getFileName(this.file.name)
        const fileName = getFileNameWithUUID(this.file.name)
        const uploadTask = firebaseStorage
          .ref()
          .child(`OutletContract/${fileName}`)
          .put(this.file)
        uploadTask.then(res => {
          fullPath = res.metadata.fullPath
          created = res.metadata.timeCreated
        })
        uploadTask.on(
          firebaseApp.storage.TaskEvent.STATE_CHANGED,
          () => {},
          () => {},
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.file = null
              this.obj.contracts.push({
                name,
                full_path: fullPath,
                url: downloadURL,
                upload_date: created
              })
            })
            this.uploading = false
          }
        )
      } catch (e) {
        this.uploading = false
        console.error(e)
      }
    }
  }
}
</script>
